import { FieldError, FieldValues } from 'react-hook-form';

interface FormInputProps {
  label: string;
  name: string;
  type?: string;
  placeholder?: string;
  register: FieldValues;
  errors?: FieldError;
  touchedField?: boolean;
  list?: any[];
}

export const FormSelect: React.FC<FormInputProps> = ({
  label,
  name,
  register,
  placeholder,
  errors,
  touchedField,
  list,
}) => {
  // Might need to add an onchange prop to then maange inside select
  return (
    <div className="w-full max-w-lg">
      <label className="block text-sm font-medium text-primary">{label}</label>
      <select
        {...register}
        className={`select w-full bg-base-100 p-2 border-2 rounded border-base-200 ${
          errors ? 'border-2 border-error' : touchedField ? 'border-2 border-success' : ''
        }`}>
        <option value={['']}>{placeholder}</option>
        {list?.map((d) => (
          <option key={d.id} value={name === 'reason' || name === 'returnReason' ? d.name : d.id}>
            {d.name}
          </option>
        ))}
      </select>
      {errors && <p className="text-red-500 text-sm">{errors?.message}</p>}
    </div>
  );
};
